import { useCallback, useState } from 'react';
import { Channel, useAppContext, useRestContext, useScripts } from 'scbk-services';

export const useIpinside = () => {
    const [isReady, setIsReady] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);
    const [isLoad, setIsLoad] = useState(false);

    const { updateContext: updateAppContext, getContext } = useAppContext();
    const { updateContext: updateRestContext } = useRestContext();
    const currentChannel = getContext().channel as Channel;

    /**
     * IPinside Sciprts import
     */
    useScripts({
        scripts:
            currentChannel === Channel.IB
                ? [
                      { src: '/resource/product/interezen/js/jquery-1.11.3.js' },
                      { src: '/resource/product/interezen/js/json2.js' },
                      { src: '/resource/product/interezen/js/IPinside_v6_config.js' },
                      { src: '/resource/product/interezen/js/IPinside_v6_engine.js' },
                  ]
                : [],
        onReady: () => {
            console.log('ipinside onReady!!!');
            if (!window.IPinside) return;
            console.log('ipinside onReady Complete!!!');
            setIsReady(true);
        },
        onError: () => {
            console.log('ipinside onError!!!');
            setIsReady(false);
        },
    });

    /**
     * IPinside install Check
     */
    const installed = useCallback(async (): Promise<boolean> => {
        const { ipinside } = getContext();

        console.log('ipinside installed start!');

        if (ipinside?.mduinfo || ipinside?.wdata) {
            console.log('ipinside installed ready!');
            return true;
        }

        return new Promise<boolean>((resolve) => {
            const object = {
                before: function () {
                    console.log('ipinside before');
                    //loading(); //로딩이미지
                },
                installCheckCallback: function (result: string) {
                    console.log('ipinside installCheckCallback');
                    console.log(result);

                    const isResult = result === 'I' ? true : false;
                    setIsInstalled(isResult);

                    resolve(isResult);
                },
            };

            window.IPinside.launchAgent(object);
        });
    }, [isReady]);

    /**
     * IPinside 실행
     */
    const load = useCallback(async (): Promise<boolean> => {
        const { ipinside } = getContext();

        console.log('ipinside load start!');

        if (ipinside?.mduinfo || ipinside?.wdata) {
            console.log('ipinside load ready!');
            return true;
        }

        return new Promise<boolean>((resolve) => {
            const object = {
                before: function () {
                    console.log('ipinside before');
                    //loading(); //로딩이미지
                },
                after: function (data: any) {
                    console.log('ipinside after');

                    if (!data) {
                        setIsLoad(false);
                        return;
                    }

                    if (data != null) {
                        console.log(data);

                        const ipinside = {
                            natip: data.ndata,
                            wdata: data.wdata,
                            mac: '',
                            mduinfo: data.udata,
                        };

                        updateAppContext({ ipinside });
                        updateRestContext({ ...ipinside });

                        setIsLoad(true);

                        resolve(true);
                    }
                },
                installCheckCallback: function (result: string) {
                    console.log('ipinside installCheckCallback');
                    console.log(result);

                    const isResult = result === 'I' ? true : false;

                    setIsInstalled(isResult);

                    if (!isResult) {
                        resolve(isResult);
                    }

                    return isResult;
                },
            };

            window.IPinside.launchAgent(object);
        });
    }, [isReady]);

    return {
        isReady,
        isInstalled,
        installed,
        isLoad,
        load,
    };
};
